import {ContextMenuButton} from '@app/web-player/context-dialog/context-dialog-layout';
import {Trans} from '@ui/i18n/trans';
import {useDialogContext} from '@ui/overlays/dialog/dialog-context';
import {Track} from '@app/web-player/tracks/track';
import {Artist} from '@app/web-player/artists/artist';
import {Album} from '@app/web-player/albums/album';
import {openDialog} from '@ui/overlays/store/dialog-store';
import React from 'react';
import {getLink, ShareMediaDialog} from '@app/web-player/sharing/share-media-dialog';
import {Playlist} from '@app/web-player/playlists/playlist';
import { LiveEvent } from '@app/admin/live-events/interfaces/live-event';
import { AppShare } from '@common/core/capacitor/app-share';
import {useTrans} from '@ui/i18n/use-trans';
import {message} from '@ui/i18n/message';

interface Props {
  item: Track | Album | Artist | Playlist | LiveEvent;
}
export function ShareMediaButton({item}: Props) {
  const {close: closeMenu} = useDialogContext();
  const {trans} = useTrans();

  return (
    <ContextMenuButton
      onClick={() => {
        closeMenu();
        if (AppShare.isNativePlatform()) {
          AppShare.share({
            name: item.name,
            url: getLink(item),
            title: trans(message('Share :name', {values: {name: item.name}})),
          });
        } else {
          openDialog(ShareMediaDialog, {
            item,
          });
        }
      }}
    >
      <Trans message="Share" />
    </ContextMenuButton>
  );
}
